import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { createPortfolio } from 'services/api/requests/portfolio';

export const useCreatePortfolio = (onErrorHierarchyNotFound?: VoidFunction) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();
	return useMutation((body: any) => createPortfolio(body), {
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['carteiraPedido-list'],
			});
			history.goBack();
			toast({
				title: 'Criada com sucesso!',
				description: 'Carteira de pedido criada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			if (error?.status === 428 || error?.response?.status === 428) {
				if (onErrorHierarchyNotFound) {
					onErrorHierarchyNotFound();
				}
			} else if (error?.response?.data?.length > 0) {
				toast({
					title: 'Erro ao criar carteira de pedido!',
					description: error.response.data[0].message,
					position: 'bottom-left',
					status: 'error',
					duration: 8000,
					isClosable: true,
				});
			} else {
				toast({
					title: 'Erro ao criar carteira de pedido!',
					description:
						'Verifique se os campos estão preenchidos corretamente. Todos os campos são de preenchimento obrigatório.',
					position: 'bottom-left',
					status: 'error',
					duration: 8000,
					isClosable: true,
				});
			}
		},
	});
};
